import TextField from "../Reusable/TextField";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
const CustomerForm = ({ register, errors, setValue, clearErrors }: any) => {
  return (
    <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <TextField
        label={"Full Name"}
        register={register("full_name")}
        errors={errors?.full_name}
      />
      <TextField
        label={"Email"}
        register={register("email")}
        errors={errors?.email}
      />
      <TextField
        label={"Mobile Number"}
        register={register("primary_contact")}
        errors={errors?.primary_contact}
      />
      <TextField
        label={"Alt Number"}
        register={register("secondary_contact")}
        errors={errors?.secondary_contact}
      />
      <TextField
        label={"Full Address"}
        register={register("address")}
        errors={errors?.address}
      />
      <TextField
        label={"VAT/PAN"}
        register={register("vat_pan")}
        errors={errors?.vat_pan}
      />
    </div>
  );
};

export default CustomerForm;
